import { Navigate } from 'react-router-dom';
const PrivateRoute = ({ allowedRoles = [], children }) => {
  const token=localStorage.getItem("token")// Assuming you have auth slice
const roles=localStorage.getItem("roles")
  // Not logged in
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Role not allowed
  if (!allowedRoles.includes(roles)) {
    return <Navigate to="/unauthorized" replace />; // Or your 403/401 page
  }

  return children;
};

export default PrivateRoute;
